module.exports = __webpack_public_path__ + "img/menu_help.4cc9fa07.svg";